import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BillingFacade, PLANS_MAP, PlanId } from '@app/shared/+state/billing';
import { EntitlementEnum } from '@app/shared/interfaces';
import { combineLatest } from 'rxjs';
import { map, switchMap, startWith } from 'rxjs/operators';

const mogulDowngradeWarning = {
  entitlement: EntitlementEnum.OwnerStatements,
  needs_action: false,
  limit: 1,
  current: 1,
  disable: 1,
};

@Component({
  standalone: false,
  selector: 'sbnb-plan-summary',
  templateUrl: './plan-summary.component.html',
  styleUrls: ['./plan-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanSummaryComponent implements OnInit {
  public pendingSubscriptionChange$ = this.billingFacade.pendingSubscriptionChange$;
  public subscription$ = this.billingFacade.subscription$;
  public hostLostBenefits = PLANS_MAP[PlanId.Host]?.lostBenefits;
  public hostFeatures = PLANS_MAP[PlanId.Host]?.features;
  public proFeatures = PLANS_MAP[PlanId.Professional]?.features.slice(0, 4);
  public proAlwaysIncluded = PLANS_MAP[PlanId.Professional]?.alwaysIncluded;
  public mogulFeatures = PLANS_MAP[PlanId.Mogul]?.features;
  public mogulComgingSoon = PLANS_MAP[PlanId.Mogul]?.comingSoon;
  public plan$ = this.billingFacade.pendingSubscriptionChangePlan$;
  public newPlanPro$ = this.plan$.pipe(map((plan) => plan?.plan_id === PlanId.Professional));
  public newPlanHost$ = this.plan$.pipe(map((plan) => plan?.plan_id === PlanId.Host));
  public newPlanMogul$ = this.plan$.pipe(map((plan) => plan?.plan_id === PlanId.Mogul));
  public downgradeChecks$ = combineLatest([this.subscription$, this.newPlanMogul$]).pipe(
    switchMap(([subscription, newPlanMogul]) => {
      return this.billingFacade.downgradeChecks$.pipe(
        startWith([]),
        map((checks) => {
          if (subscription.plan.name === 'mogul' && !newPlanMogul) {
            return [mogulDowngradeWarning, ...(checks ?? [])];
          }
          return checks;
        })
      );
    })
  );

  public smartDevicePrice$ = this.billingFacade.smartDevicePrice$;

  constructor(private readonly billingFacade: BillingFacade) {}

  ngOnInit(): void {}
}
